<template>
   <div class="footer-row"> 
      <a tabindex="0" href="/privacy">PRIVACY</a> | <a tabindex="0" href="/legal">LEGAL</a>
      <br><br>
      COPYRIGHT © {{copyrightYear}} MOBKAST INC.
      <br>
      ALL RIGHTS RESERVED.
   </div>
</template>

<script>
export default {
   name: 'Footer',
   data () {
      return {
         copyrightYear: (new Date()).getFullYear(),
      }
   },
   methods: {
      showContactForm: function () {
         this.$store.commit('showContactForm');
         this.$emit('popupContactForm');
      },      
      preventMouseDown: (e) => {}
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer-row {
   display: block;
   border-top: solid 1px #EEEEEE; /* COLOR LIGHT GREY */
   font-size: 0.88em;
   text-align: center;
   padding-top: 8em;
   color: #888888;
   min-height: 8rem;
}

h1, h2 {
   font-weight: normal;
}

h2 {
   font-weight: normal;
   font-size: 1.6em;
}

a, u {
    text-decoration: none;
}

a {
   color: #888888;
}

a:hover {
   color: black;
}

</style>



// WEBPACK FOOTER //
// src/components/site/Footer.vue